<template>
  <el-card class="box-card box-audit" v-bind:class="{ selected: record.type === current }">
    <div class="row">
      <div class="col-8" style="height: 80px;">
        <p class="time">{{ record.description }}</p>
      </div>
      <div class="col-4 text-end">
        <div class="icon icon-shape shadow-primary text-center rounded-circle right white" v-bind:class="[color]">
          {{ record.total }}
        </div>
      </div>
    </div>
    <div class="bottom clearfix">
      <el-button-group class="w-100">
        <el-button title="Objetos" class="w-50" @click="show()" type="default" icon="el-icon-truck"><span
            class="hidden-lg-and-down">Objetos</span></el-button>
        <AuditPendenciesOptions v-if="options[record.type]" :listOptions="options[record.type]" v-on:option="option" />
      </el-button-group>
    </div>
  </el-card>
</template>

<script>
import { AuditService } from "@/services/customers/audit.services";
import AuditPendenciesOptions from './AuditPendenciesOptions';

export default {
  props: ["record", "count", "current"],
  components: {
    AuditPendenciesOptions,
  },
  computed: {
    color() {
      return this.count == 0 ? 'bg-gradient-asteroid' :
        this.count == 1 ? 'bg-gradient-green' :
          this.count == 2 ? 'bg-gradient-orange' :
            this.count == 3 ? 'bg-gradient-witching' :
              this.count == 4 ? 'bg-gradient-lawrencium' :
                'bg-gradient-red';
    }
  },
  data() {
    return {
      options: {
        1: [
          { key: 'services', description: 'Verificar serviços' },
        ],
        2: [
          { key: 'cardpost', description: 'Cliente por cartão de postagem' },
          { key: 'object', description: 'Cliente por objeto' },
        ],
        3: [
          { key: '1', description: 'Usar cartão de postagem da prévia' },
          { key: '2', description: 'Usar cartão de postagem da prepostagem' },
          { key: '3', description: 'Usar outro cartão de postagem' },
        ],
        4: [
          { key: 'value', description: 'Usar valor dos correios' },
        ],
        7: [
          { key: 'value', description: 'Usar valor dos correios' },
        ]
      }
    }
  },
  methods: {
    option(action) {
      this.$emit('option', this.record.type, action);
    },
    show() {
      this.$emit('reload', this.record.type);
    },
    download(id) {
      const vm = this;
      vm.loading = true;
      AuditService.download(id)
        .then((response) => {
          var downloadLink = document.createElement("a");
          downloadLink.href = response;
          downloadLink.download = `${id}.csv`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => vm.loading = false);
    },
  }
}
</script>

<style scoped>
.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.w-25 {
  width: 25%;
}

.mr-1 {
  margin-right: 1px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.white {
  color: #fff;
}

.selected {
  background-color: #f4f4f5;
}

.box-audit {
  height: 170px;
}

.bg-gradient-asteroid {
  background: #0f2027;
  background: -webkit-linear-gradient(to right, #0f2027, #203a43, #2c5364);
  background: linear-gradient(to right, #0f2027, #203a43, #2c5364);
}

.bg-gradient-witching {
  background: #c31432;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #240b36, #c31432);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #240b36, #c31432);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

}

.bg-gradient-lawrencium {
  background: #0f0c29;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #24243e, #302b63, #0f0c29);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #24243e, #302b63, #0f0c29);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
</style>